module.exports = __webpack_public_path__ + "static/media/masthead-great-southern-herald.c3b19a37.svg";